export const accountsColumns = ["Sequence_no", "AccountName", "Address", "IdentificationNumber", "Debit", "Credit", "Balance"];

export const accountMappings = {
    Sequence_no: "Numri",
    AccountName: "Emri Llogarisë",
    Address: "Adresa",
    IdentificationNumber: "Numri Identifikues",
    Debit: "Debi",
    Credit: "Kredi",
    Balance: "Bilanci",
};


export const partnersColumns = ["Sequence_no", "AccountName", "Address", "IdentificationNumber", "Debit", "Credit", "Bilanci"];

export const partnersMappings = {
    Sequence_no: "Numri",
    AccountName: "Emri Llogarisë",
    Address: "Adresa",
    IdentificationNumber: "Numri Identifikues",
    Debit: "Debi",
    Credit: "Kredi",
    Bilanci: "Bilanci",
};

//Headers per Stokun
export const inventoryColumns = ["ArticleName", "Barcode", "ArticleGroupName", "ArticleUnitName", "TotalQtyInput", "TotalQtyOutput", "TotalQtyInStock", "CmimiMesatar", "TotalAmount"];

export const inventoryMappings = {
    ArticleName: "Emri Artikullit",
    Barcode: "Barkodi",
    ArticleGroupName: "Grupi Artikullit",
    ArticleUnitName: "Njesia Artikullit",
    TotalQtyInput: "Sasia në Hyrje",
    TotalQtyOutput: "Sasia në Dalje",
    TotalQtyInStock: "Sasia në Stok",
    CmimiMesatar: "Cmimi Mesatar",
    TotalAmount: "Vlera Totale"

};


//Headers per Stokun ne detaje
export const inventoryDetailsColumns = ["ActionType", "Barcode", "ArticleName", "PartnerName", "Date", "PriceWithoutVAT", "QTYInput", "QtyOutput", "Progressive"];

export const inventoryDetailsMappings = {
    ActionType: "Tipi",
    Barcode: "Barkodi",
    ArticleName: "Emri Artikullit",
    PartnerName: "Emri Partnerit",
    Date: "Data",
    PriceWithoutVAT: "Cmimi pa TVSH",
    QTYInput: "Sasia Hyrje",
    QtyOutput: "Sasia Dalse",
    Progressive: "Progresive"

};

//Header per detaje 

export const accountDetailColumns = ["ActionType", "AccountName", "IdentificationNumber", "Comment", "Date", "Debit", "Credit", "Progressive"];

export const accountDetailMappings = {
    ActionType: "Tipi",
    AccountName: "Emri Llogarisë",
    IdentificationNumber: "Numri Identifikues",
    Comment: "Komenti",
    Date: "Data",
    Debit: "Debi",
    Credit: "Kredi",
    Progressive: "Progresive",
};
